import {error} from '../utils/log';
import {AssetTypeConvMap} from './TbMaps';
import {AssetType, CharAssetType, OrderAction, OrderClass, OrderDuration, OrderType, PositionEffect} from './types';
import {Order} from './Order';

export class Position {
    public static makeTradeOrder(src: Position): Order {
        const order: Order = new Order();

        if (src.NoOfLegs! > 0) {
            error.log('Multileg position trade is not supported');
            throw new Error('Multileg position trade is not supported');
        } else {
            order.AccountId = src.AccountId;
            order.SubaccountId = src.SubaccountId;
            order.OrderClass = OrderClass.Single;
            order.UnderlyingSymbol = src.AssetType !== AssetType.Entity ? src.Underlying : src.Symbol;

            order.Quantity = 0;
            order.Legs = [{
                    Action: src.OpenQuantity > 0 ? OrderAction.Buy : OrderAction.Sell,
                    PositionEffect: PositionEffect.Open,
                    Symbol: src.Symbol,
                    SpreadRatio: null,
                    AssetType: src.AssetType
            }];

            order.OrderType = OrderType.Market;
            order.Duration = OrderDuration.GTC;
        }
        order.fixed = false;
        return order;
    }

    public static makeCloseOrder(src: Position): Order {
        const order: Order = new Order();
        order.fixed = true;
        if (!isNaN(src.NoOfLegs!) && src.NoOfLegs! > 0) {
            error.log('Multileg position close is not supported');
            throw new Error('Multileg position close is not supported');
        } else {

            order.AccountId = src.AccountId;
            order.SubaccountId = src.SubaccountId;
            order.OrderClass = OrderClass.Single;

            order.UnderlyingSymbol = src.AssetType !== AssetType.Entity ? src.Underlying : src.Symbol;

            order.Quantity = Math.abs(src.OpenQuantity);
            order.Legs = [{
                Action: src.OpenQuantity > 0 ? OrderAction.Sell : OrderAction.Buy,
                PositionEffect: PositionEffect.Close,
                Symbol: src.Symbol,
                SpreadRatio: null,
                AssetType: src.AssetType
            }];
            order.OrderType = OrderType.Limit;
            order.Duration = OrderDuration.GTC;
            // rder.N = src.N ;
        }
        order.fixed = true;
        return order;
    }

    public Symbol: string = '';
    public DateOpened: Date | null | string = null;
    public Description: string = '';
    public AssetType: AssetType = AssetType.Undefined;
    public Underlying: string;
    public AskPrice?: number;
    public CostBasis?: number;
    public OpenQuantity: number = 0;
    public OpenPrice: number = 0;
    public Commission: number = 0;
    // TotalCostBasis : total_cost.formatPrice() ,
    public CurrentValue?: number;
    public UnrealizedGain?: number;
    public BidPrice?: number;
    public NetChange?: number;
    public N?: number;
    public OptionMultiplier?: number;
    public LastTradePrice?: number;
    public NoOfLegs: number | null;
    public HasWorkingOpenOrder: boolean;
    public StrategyTypeId: number;
    public SubaccountId: number;

    public AccountId: number;
    public GroupId: number;
    public HasWorkingCloseOrder: boolean;


}